import { render, staticRenderFns } from "./PackTable.vue?vue&type=template&id=bad0c49e"
import script from "./PackTable.vue?vue&type=script&lang=js"
export * from "./PackTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports